import { SVGProps } from 'react';

export function InstagramSendIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M29 3L3 15l12 2.5M29 3L19 29l-4-11.5M29 3L15 17.5"
      ></path>
    </svg>
  );
}
